import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, computed, useSlots, onBeforeUnmount } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextBlockWithOverflowTooltip',
  props: {
  textContent: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props;



const checkOverflow = () => {
  if (textBlock.value) {
    const element = textBlock.value;
    textOverflow.value = element.scrollWidth > element.clientWidth;
  }
};

const textOverflow = ref(false);
const textBlock = ref<HTMLElement>();
const resizeObserver = new ResizeObserver(checkOverflow);

const slots = useSlots();

const tooltipText = computed(() => {
  if (!textOverflow.value) {
    return '';
  }
  if (slots.default) {
    const slot = slots.default();
    return slot[0].text || slot[0].elm?.textContent || props.textContent;
  }
  return props.textContent;
});

onMounted(() => {
  checkOverflow();

  if (textBlock.value) {
    resizeObserver.observe(textBlock.value);
  }
});

onBeforeUnmount(() => {
  resizeObserver.disconnect();
});

return { __sfc: true,props, checkOverflow, textOverflow, textBlock, resizeObserver, slots, tooltipText }
}

})